import { render, staticRenderFns } from "./anthologyDetail.vue?vue&type=template&id=7085791b&scoped=true"
import script from "./anthologyDetail.vue?vue&type=script&lang=js"
export * from "./anthologyDetail.vue?vue&type=script&lang=js"
import style0 from "./anthologyDetail.vue?vue&type=style&index=0&id=7085791b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7085791b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7085791b')) {
      api.createRecord('7085791b', component.options)
    } else {
      api.reload('7085791b', component.options)
    }
    module.hot.accept("./anthologyDetail.vue?vue&type=template&id=7085791b&scoped=true", function () {
      api.rerender('7085791b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/select/anthologyDetail.vue"
export default component.exports